// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// categories.js
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_LOADING = 'SET_LOADING'

export const SET_COURSES = 'SET_COURSES'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_COURSE = 'SET_COURSE'
export const SET_CART_ITEMS = 'SET_CART_ITEMS'
export const SET_USER_CAN_ACCESS = 'SET_USER_CAN_ACCESS'

// lesson
export const SET_LESSONS = 'SET_LESSONS'

export const SET_CURRENT_AUTHOR_COURSE = 'SET_CURRENT_AUTHOR_COURSE'